import configApi from '@/api/config/config-api';

export default {
  namespaced: true,
  actions: {
    async fetch() {
      try {
        const response = await configApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
}
